<template>
    <Paper class="RegistrationMain">
        <div class="IdentityRegistrationLog">
            <el-row>
                <el-col :span="22">
                    <el-row>
                        <el-col class="IdentityRegistrationLog-search">
                            <el-input v-model="inquireData['enterpriseName']" :placeholder="$translate('lang.E3202103220015', { defaultText: '企业名称' })"></el-input>
                        </el-col>
                        <el-col class="IdentityRegistrationLog-search">
                            <el-input v-model="inquireData['productCode']" :placeholder="$translate('lang.E3202102220013', { defaultText: '产品编码' })"></el-input>
                        </el-col>
                        <el-col class="IdentityRegistrationLog-search">
                            <el-input v-model="inquireData['identityCode']" :placeholder="$translate('lang.E3202103080001', { defaultText: '标识编码' })"></el-input>
                        </el-col>
                        <el-col class="IdentityRegistrationLog-search">
                            <el-input v-model="inquireData['operator']" :placeholder="$translate('lang.E3202103230001', { defaultText: '操作用户' })"></el-input>
                        </el-col>
                        <div>
                            <el-button type="primary" :loading="Searchloading" size="mini" @click="searchChange" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </el-row>
                    <el-row class="IdentityRegistrationLog-second-row">
                        <el-col class="IdentityRegistrationLog-search">
                            <el-input v-model="inquireData['dataSource']" :placeholder="$translate('lang.E3202103230002', { defaultText: '注册来源' })"></el-input>
                        </el-col>
                        <el-col class="IdentityRegistrationLog-search">
                            <el-date-picker class="IdentityRegistrationLog-date" v-model="inquireData['establishTime']" type="datetimerange" align="left" value-format='yyyy-MM-dd HH:mm:ss'
                                :default-time="['00:00:00', '23:59:59']" unlink-panels range-separator="-" :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })" size="mini" :picker-options="pickerOptions"></el-date-picker>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="showRegistrationMain">
            <Registration-table ref="RegistrationTable" :pageTotal="RegistrationTotal" :tableData="RegistrationTableData" @pageChange="RegistrationPage" @sizeChange="RegistrationSize"
                :config="RegistrationConfig">
            </Registration-table>
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="12">
                    <el-button type="primary" size="mini" @click="searchExport" icon="el-icon-upload2">
                        {{$translate('lang.E3202103220006', { defaultText: '导出' })}}
                    </el-button>
                </el-col>
                <el-col :span="12">
                    <div class="IdentityRegistrationLog-total">
                        <div class="IdentityRegistrationLog-page" @click="showPage" v-show="!pageStatus">
                            <img src="../../../assets/images/eyes.svg" alt="" />
                            <span class="IdentityRegistrationLog-total-num">{{$translate('lang.E3202110090005', { defaultText: '查看总数' })}}</span>
                        </div>
                        <span v-show="pageStatus">
                            <el-pagination layout="total" :total="RegistrationTotal"> </el-pagination>
                        </span>
                        <span class="IdentityRegistrationLog-page-size">{{$translate('lang.E3202110190001', { defaultText: '200条/页' })}}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import RegistrationTable from '../../../components/IdentityComponent/Main';
import RegistrationConfig from './config.js';
import formatTime from '@/utils/common.js';
import { getregisterLog, exportType } from '../../../api/logManagement';
export default {
    name: 'IdentityRegistrationLog',
    components: { Paper, RegistrationTable },
    data() {
        return {
            RegistrationConfig: RegistrationConfig,
            inquireData: {
                enterpriseName: '',
                productCode: '',
                identityCode: '',
                opName: '',
                dataSource: ''
            },
            Searchloading: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202110090003', { defaultText: '当天' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(0), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    }
                ]
            },
            RegistrationTableData: [],
            RegistrationTotal: 0,
            page: {
                pageSize: 200,
                pageNo: 1
            },
            pageStatus: false
        };
    },
    methods: {
        restSearchChange() {
            this.inquireData['enterpriseName'] = '';
            this.inquireData['productCode'] = '';
            this.inquireData['identityCode'] = '';
            this.inquireData['opName'] = '';
            this.inquireData['dataSource'] = '';
            this.getTime();
        },
        getTime() {
            const start = new Date();
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);
            const end = new Date();
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
            this.$set(this.inquireData, 'establishTime', [formatTime.formatDate(start) + ' 00:00:00', formatTime.formatDate(end) + ' 23:59:59']);
        },
        getData(params) {
            if (params.establishTime) {
                params['startTime'] = params['establishTime'][0];
                params['endTime'] = params['establishTime'][1];
            };
            delete params.establishTime;
            getregisterLog(params).then(res => {
                if (+res.code === 0) {
                    this.RegistrationTotal = res.data.totalCount;
                    this.RegistrationTableData = res.data.list;
                }
                this.Searchloading = false;
            }).catch(res => {
                this.Searchloading = false;
            });
        },
        searchValid(params) {
            const checkBy = true;
            if (!params.establishTime) {
                this.$message.warning(this.$translate('lang.E3202110090007', { defaultText: '请选择操作时间查询' }));
                // checkBy = false;
                return;
            }
            const paramsSet = !params.enterpriseName && !params.productCode && !params.identityCode && !params.operator && !params.dataSource;
            if (paramsSet) {
                this.$message.warning(this.$translate('lang.E3202110090008', { defaultText: '除时间外，需要选择任意一查询条件查询' }));
                // checkBy = false;
                return;
            }
            if (params.enterpriseName || params.operator || params.dataSource) {
                const startTimestamp = new Date(params.establishTime[0]).getTime();
                const endTimestamp = new Date(params.establishTime[1]).getTime();
                if ((endTimestamp - startTimestamp) > 7 * 24 * 60 * 60 * 1000) { // 7 * 24 * 60 * 60 * 1000 7天
                    this.$message.warning(this.$translate('lang.E3202110110001', { defaultText: '当查询条件为企业名称、操作用户、注册来源时，操作时间范围限制为7天' }));
                    // checkBy = false;
                    return;
                }
            }
            return checkBy;
        },
        searchChange() {
            const params = {
                ...this.page,
                ...this.inquireData
            };
            if (!this.searchValid(params)) {
                return;
            }
            this.Searchloading = true;
            this.pageStatus = false;
            this.getData(params);
        },
        searchExport() {
            const params = {
                ...this.inquireData
            };
            if (params.establishTime) {
                params['startTime'] = params['establishTime'][0];
                params['endTime'] = params['establishTime'][1];
            };
            delete params.establishTime;
            const url = '/api-sn/log/identity/register-export';
            const type = 'post';
            const name = this.$translate('lang.E3202103250001', { defaultText: '标识注册日志.xls' });
            exportType(params, url, type, name);
        },
        RegistrationPage(pageNo) {
            this.page['pageNo'] = pageNo;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        },
        RegistrationSize(pageSize) {
            this.page['pageSize'] = pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        },
        showPage() {
            this.pageStatus = true;
        }
    },
    mounted() {
        this.getTime();
    }
};
</script>
<style lang="less">
.IdentityRegistrationLog {
    .IdentityRegistrationLog-search {
        width: 190px;
        margin-right: 10px;
    }
    .IdentityRegistrationLog-date {
        width: 100%;
        .el-range__icon {
            display: none;
        }
    }
}
.IdentityRegistrationLog-second-row {
    margin-top: 12px;
}
.showRegistrationMain {
    margin-top: 20px;
    .nPanel .el-table {
        height: calc(100vh - 220px) !important;
    }
    .nPanel .row-bg {
        margin-top: 20px;
    }
}
.IdentityRegistrationLog-total {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    .el-pagination {
        padding: 0;
    }
}
.IdentityRegistrationLog-page-size {
    line-height: 28px;
    color: #555757;
}
.IdentityRegistrationLog-page {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 6px;
    width: 82px;
    height: 28px;
    margin-right: 10px;
    border: 1px solid #4285f5;
    border-radius: 3px;
    cursor: pointer;
}
.IdentityRegistrationLog-total-num {
    font-size: 12px;
    color: #4285f5;
}
</style>